module.exports = __webpack_public_path__ + "media/singpt.5b549581.mp4";